import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChatIaService } from '../../services/chat-ia/chat-ia.service';

@Injectable({
  providedIn: 'root',
})
export class ChatIaEnabledGuard {

  constructor(
    private chatIaService: ChatIaService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.chatIaService.habilitado().pipe(
      map((ok) => ok || this.router.parseUrl('/')),
    );
  }
}
